import triggerDownload from "../../../helpers/triggerDownload";

export const REPORT_JOB_POLL_INTERVAL_MS = 3000;
const IN_PROGRESS_REPORT_STATUSES = ["pending", "running"];

const wait = ms => new Promise(resolve => setTimeout(resolve, ms));

export const waitForReportJob = async (api, reportFileId) => {
  let job = await api.factoring.reportJob(reportFileId);
  while (IN_PROGRESS_REPORT_STATUSES.includes(job.status)) {
    await wait(REPORT_JOB_POLL_INTERVAL_MS);
    job = await api.factoring.reportJob(reportFileId);
  }
  if (job.status !== "complete") {
    const error = new Error(job.error || "There was an error exporting this report");
    error.reportJobError = error.message;
    throw error;
  }
  return job;
};

const fetchFactoringCollatedFiles = (id, data, isDebtor) => async (
  dispatch,
  getState,
  { api }
) => {
  const response = !isDebtor
    ? await api.factoring.report(id, data)
    : await api.factoring.debtorReport({ factoring_id: id, async: true, ...data });

  if (isDebtor && response?.report_file_id) {
    const job = await waitForReportJob(api, response.report_file_id);
    triggerDownload(job.download_url);
    return job;
  }

  if (response.length > 0 && response[0]?.download_url) {
    triggerDownload(response[0].download_url);
  } else {
    triggerDownload(response.download_url);
  }

  return response;
};

export default fetchFactoringCollatedFiles;
